<template>
  <v-dialog v-model="dialog" width="700">
    <template v-slot:activator="{ on, attrs }">
      <i-btn class="ml-2 btn-type-06" v-bind="attrs" v-on="on">결과보기</i-btn>
    </template>
    <v-card>
      <v-card-title class="headline">{{ $t('결과 보기') }}</v-card-title>
      <v-card-text>
        <v-container>
          <div class="box-body">
            <div class="inner-wrap">
              <!-- <ckeditor
                :editor="editor"
                :config="editorConfig"
                @ready="editorReadonly"
                v-model="result"
              ></ckeditor> -->
              <CommonCkEditor
                :isReadOnly="true"
                @ready="editorReadonly"
                v-model="result"
              />
            </div>
          </div>
        </v-container>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <i-btn elevation="0" color="normal" @click="dialog = false">닫기</i-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import CommonCkEditor from '@/components/common/CommonCkEditor.vue';

export default {
  components: { CommonCkEditor },
  name: 'PopApplyResult',
  props: {
    result: { type: String },
  },
  data() {
    return {
      dialog: false,
      // editor: DecoupledDocument,
      // editorConfig: { extraPlugins: [Base64Upload] },
    };
  },
  methods: {
    editorReadonly(editor) {
      //READ-ONLY
      editor.isReadOnly = true;
      var element = editor.ui.view.toolbar.element;
      element.style.display = 'none';

      editor.ui
        .getEditableElement()
        .parentElement.insertBefore(element, editor.ui.getEditableElement());
    },
  },
};
</script>
